import { Spinner } from 'tamagui';

export default Spinner;
